import React from "react";

import { SubStepLabels } from "../SubStepLabels";

export const InviteResidentsSteps = (props: any) => {
  const { inviteResidentsStepsList } = props;

  return (
    <div className={"flex flex-col justify-start items-start"}>
      {inviteResidentsStepsList.map((step: any) => (
        <SubStepLabels key={step.name} step={step} />
      ))}
    </div>
  );
};
